<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-warning">
               <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="house" aria-hidden="true"></b-icon>
            </div>
            <div slot="content">
              <p class="card-category">Houses</p>
              <h4 class="card-title">{{totalHouses}}</h4>
            </div>
            <div slot="footer">
              <b-icon icon="plus" aria-hidden="true"></b-icon>
              Total
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <b-icon style="color: rgb(37, 91, 48)" icon="cash-coin" aria-hidden="true"></b-icon>
            </div>
            <div slot="content">
              <p class="card-category">Total Revenue</p>
              <h4 class="card-title">{{numberWithCommas(totalPaid)}}</h4>
            </div>
            <div slot="footer">
              <b-icon icon="calendar2" aria-hidden="true"></b-icon>This month
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="bookmark-dash" aria-hidden="true"></b-icon>
            </div>
            <div slot="content">
              <p class="card-category">Unpaid Rent</p>
              <h4 class="card-title">{{numberWithCommas(totalUnpaid+totalOverdue)}}</h4>
            </div>
            <div slot="footer">
              <b-icon icon="calendar2" aria-hidden="true"></b-icon>This month
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <b-icon style="color: #51494c;" icon="exclamation-octagon" aria-hidden="true"></b-icon>
            </div>
            <div slot="content">
              <p class="card-category">Overdue Rent</p>
              <h4 class="card-title">{{numberWithCommas(totalOverdue)}}</h4>
            </div>
            <div slot="footer">
              <b-icon icon="calendar2" aria-hidden="true"></b-icon>This month
            </div>
          </stats-card>
        </div>

      </div>
      <div class="row">
        <div class="col-md-4" >
          <b-card style="display: flex; justify-content: center; align-items: center;">
            <apexchart width="500" type="pie" :options="pieChart.chartOptions" :series="pieChart.series"></apexchart>
          </b-card>
        </div>
        <div class="col-md-8">
          <b-card style="display: flex; justify-content: center; align-items: center;">
            <div class="row" style="display: flex; justify-content: end; align-items: end;">
              <b-form-select style="width: 20%;" v-model="currentYear" :options="yearOptions" size="sm" @change="getMonthlyTotalIncome()" class="mt-3"></b-form-select>
            </div>
            <div class="row">
              <apexchart width="700" height="350" type="bar" :options="barChart.chartOptions" :series="barChart.series"></apexchart>
            </div>
          </b-card>
        </div>
      </div>
 </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        pieChart:{
          chartOptions: {
            chart: {
              id: "apexchart-example",
            },
            title: {
              text: "Statistics",
              align: "center",
              style: {
                fontSize: "20px",
                fontWeight: "400",
                color: "#9A9A9A",
              },
            },
            colors: [],
            dataLabels: {
              enabled: true,
            },
            legend: {
              show: true,
              position: 'bottom',
            },
              labels: [],
          },
          series: [],
        },
        barChart:{
          chartOptions: {
            chart: {
              id: 'vuechart-example'
            },
            title: {
              text: "This Year Revenue",
              align: "center",
              margin: 40,
              style: {
                fontSize: "20px",
                fontWeight: "400",
                color: "#9A9A9A",
              },
            },
            xaxis: {
              categories: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]
            },
            colors: ['#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30']
          },
          series: [{
            name: 'series-1',
            data: [0,0,0,0,0,0,0,0,0,0,0,0]
          }]
        },
        mainRole: sessionStorage.getItem("mainRole"),
        totalRevenueExpected: 0,
        totalPaid: 0,
        totalUnpaid: 0,
        totalOverdue: 0,
        totalHouses: 0,
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        currentYear: null,
        yearOptions: [
          { text: "2022", value: 2022},
          { text: "2023", value: 2023},
          { text: "2024", value: 2024},
          { text: "2025", value: 2025},
          { text: "2026", value: 2026},
          { text: "2027", value: 2027},
          { text: "2028", value: 2028},
          { text: "2029", value: 2029},
          { text: "2030", value: 2030},
          { text: "2031", value: 2031},
          { text: "2032", value: 2032}
        ],
        spin: false,
      }
    },
    beforeMount() {
      
    },
    mounted() {
      if(this.mainRole === "OWNER" || this.mainRole === "COLLECTOR") {
        this.loadPieChartData();
        this.getHouseByOwnerID();
        this.getMonthlyTotalIncome();
      } else {
        console.warn("Overview: mainRole not set or unrecognized:", this.mainRole);
      }
    },
    computed: {

    },
    watch: {

    },
    methods: {
      async loadPieChartData() {
        const userId = sessionStorage.getItem("ID");
        const isOwner = this.mainRole === "OWNER";
        const paidAction     = isOwner ? 'getPaidAmountAndList'           : 'getPaidAmountAndListOwner';
        const unpaidAction   = isOwner ? 'getUnPaidAmountAndList'         : 'getUnPaidAmountAndListOwner';
        const overdueAction  = isOwner ? 'getOverdueListAndTotalAmount'   : 'getOverdueListAndTotalAmountOwner';
        try {
          const [paidRes, unpaidRes, overdueRes] = await Promise.all([
            this.$store.dispatch(paidAction,    { userId }),
            this.$store.dispatch(unpaidAction,  { userId }),
            this.$store.dispatch(overdueAction, { userId }),
          ]);
          this.totalPaid    = paidRes.data.totalPaid;
          this.totalUnpaid  = unpaidRes.data.totalUnpaid;
          this.totalOverdue = overdueRes.data.totalOverdue;
          this.totalRevenueExpected = this.totalPaid + this.totalUnpaid + this.totalOverdue;
          // Replace chartOptions as a new object so ApexCharts reacts properly
          this.pieChart.chartOptions = {
            ...this.pieChart.chartOptions,
            colors: ['#255b30', '#F0CE0D', '#51494C'],
            labels: ['Paid', 'Unpaid', 'Overdue'],
          };
          this.pieChart.series = [this.totalPaid, this.totalUnpaid, this.totalOverdue];
        } catch (error) {
          console.log(error);
        }
      },
      async getPaidAmountAndList() {},
      async getUnPaidAmountAndList() {},
      async getOverdueListAndTotalAmount() {},
      getHouseByOwnerID(){
         this.$store.dispatch('getHouseByOwnerID', {userId: sessionStorage.getItem("ID")})
          .then(response=>{
              this.totalHouses = response.data.length;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              console.log(error);
          })
      },
      async getMonthlyTotalIncome() {
        this.spin = true;
        if (this.currentYear == null) this.currentYear = new Date().getFullYear();
        const action = this.mainRole === 'OWNER' ? 'getMonthlyTotalIncome' : 'getMonthlyTotalIncomeOwner';
        try {
          const response = await this.$store.dispatch(action, { userId: sessionStorage.getItem('ID'), whichYear: this.currentYear });
          const p = response.data.perMonth;
          this.barChart = {
            ...this.barChart,
            series: [{ name: 'series-1', data: [p.Jan, p.Feb, p.Mar, p.Apr, p.May, p.Jun, p.Jul, p.Aug, p.Sep, p.Oct, p.Nov, p.Dec] }]
          };
        } catch (error) {
          this.$notifications.notify({ message: error.response.data, horizontalAlign: 'center', verticalAlign: 'top', type: 'danger' });
        } finally {
          this.spin = false;
        }
      },
      numberWithCommas(x) {
        if(x !== null && x !== undefined){
            x = x.toFixed(2);
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
    }
  }
</script>
<style>
 .ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
    fill: rgba(240, 206, 13, 0.973);
  }

  .ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
    fill: rgb(37, 91, 48, 0.6);
  }
  .ct-series-c .ct-slice-pie, .ct-series-c .ct-area {
    fill: #FB404B !important;
  }
  .ct-series-a .ct-bar{
    stroke: rgba(240, 206, 13, 0.973);
  }
  @media (max-width: 500) {
    #vuechart-example{
      width: 250px;
      height: 200px;
    }
  }
</style>
